<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <template>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title> Sedes sucursal </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn class="green darken-2 white--text" @click="editItem()">
              <v-icon small class="mr-2">
                mdi-pencil
              </v-icon>
              Agregar
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.opciones`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small color="red" class="darken-4 mr-4" dark v-bind="attrs" v-on="on" @click="preeliminar(item)">
                mdi-delete
              </v-icon>
            </template>
            <span> Eliminar </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="green"
                class="darken-4 mr-4"
                dark
                small
                v-bind="attrs"
                v-on="on"
                @click="abrircufds(item.codigo_punto_venta)"
              >
                mdi-credit-card-marker-outline
              </v-icon>
            </template>
            <span> Registrar Cufd </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="green"
                class="darken-4"
                dark
                small
                v-bind="attrs"
                v-on="on"
                @click="abrirevento(item.codigo_punto_venta)"
              >
                mdi-bullhorn
              </v-icon>
            </template>
            <span> Registrar Ev. Significativo </span>
          </v-tooltip>
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loading: false,
      headers: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Descripcion', value: 'descripcion' },
        { text: 'Estado Facturacion', value: 'estado_facturacion' },
        { text: 'Codigo Punto Venta', value: 'codigo_punto_venta' },
        { text: 'Tipo Punto Venta', value: 'tipo_punto_venta' },
        { text: 'SucursalVenta', value: 'sucursal_id' },
        { text: 'Opciones', value: 'opciones', sortable: false, width: 150 },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    }),

    components: {},

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
      dialogDelete(val) {
        val || this.closeDelete();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        let vue = this;
        let idsucursal = this.$route.query.idsucursal;
        vue.loading = true;
        var config = {
          method: 'get',
          //url: `${process.env.VUE_APP_API_REST}/api/v1/esam/puntosventas`,
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/puntosventas?sucursalId=${idsucursal}`,
          headers: {
            //apikey: '4265269017',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            vue.desserts = data;
            vue.loading = false;
            window.console.log(vue.desserts);
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },

      newregpventa(item) {
        let e = this.desserts.find((x) => x.id == item.id);
        if (e) {
          e.codigoPuntoVenta = item.codigoPuntoVenta;
          e.descripcion = item.descripcion;
          e.estado = item.estado;
          e.nombre = item.nombre;
          e.sucursalId = item.sucursalId;
          e.tipoPuntoVenta = item.tipoPuntoVenta;
        } else {
          this.desserts.push(item);
        }
      },
      newregevento() {},

      editItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialog = true;
        let idsucursal = this.$route.query.idsucursal;
        let numsucursal = this.$route.query.numsucursal;
        this.$refs.puntoreg.openmodal(item, idsucursal, numsucursal);
      },

      preeliminar(item) {
        window.console.log(item);
        let vue = this;
        let opt = {
          verification: 'eliminar',
          verificationHelp: 'Escriba "[+:verification]" para eliminar el punto de venta.',
          okText: 'Eliminar Punto',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'hard',
        };
        var message = {
          title: 'Confirmar eliminacion',
          body: '<br> <b>NOTA:</b> Esta accion es ireeversible.',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function(dialog) {
            vue.deleteItem(item, dialog);
          })
          .catch(function() {});
      },
      deleteItem(item, dialog) {
        var config = {
          method: 'delete',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/puntosventas/${item.id}`,
          headers: {
            apikey: this.$store.getters.getApiKey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log(data);
            dialog.close();
          })
          .catch(function(error) {
            window.console.log(error);
            dialog.close();
          });
      },

      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
    },
  };
</script>
